import cx from 'classnames';
import {ReactNode} from 'react';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';

import './Header.sass';

type HeaderProps = {
  title?: ReactNode;
  onClose?: () => void;
  hideClose?: boolean;
  centered?: boolean;
};

export const Header = ({title, onClose, centered, hideClose}: HeaderProps) => {
  const isLargishAndUp = useIsLargishAndUp();

  return (
    <div className="rsvp-header">
      <div
        className={cx('rsvp-header__title__wrapper', {
          'rsvp-header__title__wrapper--centered': centered,
        })}
      >
        {title && (
          <Typography
            variant={isLargishAndUp ? 'header2' : 'header3'}
            classNames="rsvp-brut"
            semibold
          >
            {title}
          </Typography>
        )}
      </div>

      {!hideClose && onClose && (
        <Button
          variant="unstyled-button"
          onClick={onClose}
          data-qa-id="close-button"
          className="rsvp-header__close-button"
        >
          <CloseLineIcon ratio={0.75} />
        </Button>
      )}
    </div>
  );
};
